import background from "../../assets/background.png";



export default function Projects() {
    return(
      <div class="contact">
<h1>Contact</h1>
<h2>Sandra Sanders</h2>
<h2>sandy-sanders@msn.com</h2>
<h4>https://github.com/sandy-06</h4>
<h4>https://www.linkedin.com/in/sandy-sanders-22190210/</h4>
<h4>https://stackoverflow.com/users/16669020/sandy16</h4>





      </div>
    )
    
  }
  
  
  